
import {
  Component,
  namespace,
  Vue,
  State,
  Watch
} from 'nuxt-property-decorator';
import DownloadSitemapButton from '~/components/ui/sitemap/DownloadSitemapButton.vue';
import CloseBtn from './CloseBtn.vue';
import NewPdfButton from '~/components/ui/side-panel/notes/NewPdfButton.vue';
import NotesStore from '@/store/notes.store';
import {
  NoteHighlight,
  NoteHighlightRecreation
} from '@/types/highlightContract';
import { Site, Page } from '@/types/pageContract';
import { ITextStartEndObject } from '@/types/highlightServerTypes';
import SidePanelStore from '@/components/ui/side-panel/side-panel.store';
import KeyHandleEventBus from '@/store/keyHandle.eventbus';

const highlightsModule = namespace('highlights.store');

@Component({
  components: { DownloadSitemapButton, NewPdfButton, CloseBtn }
})
export default class DevelopmentMenu extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  // @ts-ignore
  @State((state) => state.typo3?.page?.page?.id) // notice : there's also id, and that reflects the query param
  pageId: string;

  // @ts-ignore
  @State((state) => state.typo3?.page?.page)
  page: Page;

  @highlightsModule.Action
  addHighlightToPage: ({
    pid: string,
    site: Site,
    highlight: NoteHighlight,
    page: Page
  }) => Promise<NoteHighlight>;

  @highlightsModule.Getter
  highlightsForPid: (pid: string) => NoteHighlight[];

  showPageHighlights: boolean = NotesStore.showPageNotesOnly;

  closeSidePanel(): void {
    SidePanelStore.rightPanelIsOpen = false;
  }

  @Watch('showPageHighlights')
  showPageHighlightsChanged(change: boolean) {
    NotesStore.showPageNotesOnly = change;
  }

  mounted() {
    KeyHandleEventBus.$on('escape', this.closeSidePanel);
  }

  destroyed() {
    KeyHandleEventBus.$off('escape', this.closeSidePanel);
  }

  async addPageHighlight() {
    console.log('adding page highlight');
    const cid = prompt('Write a CID', '0');
    if (cid) {
      await this.createPageHighlightAndSave(Number(cid));
      location.reload();
    }
  }

  randomHLColor(): string {
    const hlColor = [
      'hl-yellow',
      'hl-red',
      'hl-green',
      'hl-blue',
      'hl-purple',
      ''
    ];

    return hlColor[Math.floor(Math.random() * hlColor.length)];
  }

  async createPageHighlightAndSave(cid: number) {
    const selectedTextStartAndEndObject: ITextStartEndObject = {
      startSelectedText: '',
      endSelectedText: ''
    };

    const recreationData: NoteHighlightRecreation = {
      startCID: cid,
      numberOfSiblingsOnStartNode: 0,
      numberofPrevSiblingsOnCIDStartNode: 0,
      startCtypes: null,
      endCID: cid,
      numberOfSiblingsOnEndNode: 0,
      numberofPrevSiblingsOnCIDEndNode: 0,
      endCTypes: null,
      startSelectionInnerText: '',
      endSelectionInnerText: '',
      mathObject: '',
      selectedTextStartAndEndObject,
      totalSiblingsToCIDs: 0,
      ibkngData: {
        cid,
        isPageNote: cid === 0
      },
      specialSelectedText: '',
      source: null
    };

    const newHighlight: NoteHighlight = {
      userComment: 'Created by devtools',
      hlcolor: this.randomHLColor(),
      id: null,
      createdTimestamp: null,
      timestampSortKey: null,
      selectedText: '',
      ranges: [],
      recreationData,
      pid: '' + this.pageId
    };

    const { highlight } = await this.addHighlightToPage({
      pid: this.pageId,
      site: this.site,
      highlight: newHighlight,
      page: this.page
    });
    console.log(`Added highlight.`, highlight);
  }
}
